export default __webpack_public_path__ + "static/media/tap_button_disable.5c474142.png";